import { Icon } from "@chakra-ui/react"
import { IoPeopleOutline } from '@react-icons/all-files/io5/IoPeopleOutline';

export const TeamIcon = (props: any) => (
  <Icon {...props} as={IoPeopleOutline} />
);
